import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Microalgae are a valuable source of triglycerides, vitamins,
              pigments, and essential amino acids and are widely used as an
              important biological resource in various sectors, including the
              food sector, the manufacturing of biofuels, wastewater treatment,
              cosmetics, and medicines. Unplanned anthropogenic activities have
              been impacting aquatic ecosystems, evidenced by the erosion of the
              physicochemical characteristics and microalgae composition of the
              lakes in the Hebbal-Nagavara Valley, Bangalore city. The current
              investigation documents microalgal species of the groups
              Cyanophyta, Chlorophyta, Euglenozoa, Bacillariophyta, Charophyta,
              Ochrophyta, Glaucophyta, and Chlorophyta, which constitute a
              dominant group. The diversity indices showed the extent of lake
              pollution. Cluster analysis of 32 lakes in Hebbal-Nagavara Valley
              showed that Group-1 lakes are more polluted with less
              phytoplankton diversity than Group-2 lakes, necessitating urgent
              restoration and conservation measures to prevent further
              eutrophication. Microalgae based biorefineries are emerging as a
              viable industry for manufacturing biofuels and value-added goods
              such as protein, pigment, and antioxidants, which support the
              livelihood of local people at disaggregated levels. Lakes, rich in
              microalgal biomass, generate valuable bioproducts and offer
              environmental benefits like bioremediation and nutrient cycling.
              These microalgae may be separated and farmed on a vast scale,
              providing long-term, environmentally favourable options as the
              world seeks sustainable solutions. The city should implement
              restoration programs and initiate conservation measures involving
              local stakeholders in and around the lakes.
            </p>
            <p>
              <strong>ACKNOWLEDGEMENTS</strong>
            </p>
            <p>
              We thank the EIACP-ENVIS Division, The Ministry of Environment,
              Forests and Climate Change, the Government of India, and the
              Indian Institute of Science (IISc) for their sustained support of
              ecological research.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
